
    import { Vue, Component } from 'vue-property-decorator';

    @Component({
        name: 'ProductCatalogIcon',
    })
    export default class ProductCatalogIcon extends Vue {

    }
